<template>
    <div class="full-page bg-primary">
        <div v-if="!success" class="uk-card uk-card-body uk-card-default uk-position-center">
            <h1 class="uk-card-title">Wachtwoord Veranderen</h1>
            <div class="uk-margin">
                <input class="uk-input" type="password" name="email" v-model="oldPassword" placeholder="Oud Wachtwoord"/>
            </div>
            <div class="uk-margin">
                <input class="uk-input" type="password" name="email" v-model="password" placeholder="Nieuw Wachtwoord"/>
            </div>
            <div v-if="error" class="uk-alert-danger">{{error.code}}</div>
            <button class="uk-button uk-button-primary uk-align-right" type="submit" :disabled="loading" @click.prevent="ChangePassword"><span v-if="!loading">AANPASSEN</span><div v-if="loading" uk-spinner></div></button>
        </div>
        <div v-if="success" class="uk-card uk-card-body uk-card-default uk-position-center">
            <h1 class="uk-card-title">Wachtwoord veranderd!</h1>
            <router-link class="uk-button uk-button-primary" to="/">Klaar!</router-link>
        </div>
    </div>
</template>
<script>
import * as firebase from 'firebase'
import {db, auth} from '@/CUSTOM/helpers/firebase'
    export default {
        name: 'ChangePassword',
        data () {
            return {
                password: '',
                oldPassword: '',
                error: null,
                success: false,
                loading: false
            }
        },
        created() {
            this.$emit('loading', false)
        },
        methods: {
            ChangePassword () {
                this.loading=true
                const credential = firebase.auth.EmailAuthProvider.credential(
                    auth.currentUser.email, 
                    this.oldPassword
                );
                auth.currentUser.reauthenticateWithCredential(credential).then(() => {
                    return auth.currentUser.updatePassword(this.password)
                }).then(() => {
                    this.success = true
                    this.loading = false
                }).catch((error) => {
                    this.loading = false
                    this.error = error
                    if(error.code == 'auth/user-not-found') {
                        this.success = true
                    }
                });
                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ChangePassword.vue?4d6802d9